import React, { useState, useEffect  } from "react";
import ReactJson from "react-json-view";

const MongoJsonViewer = ({result_mongo}) => {
const [theme, setTheme] = useState("rjv-default");

  const [data] = useState({
    find: "users",
    filter: {
      age: { $gt: 25 },
      isActive: true,
    },
    projection: {
      _id: 0,
      name: 1,
      email: 1,
    },
  });

   useEffect(() => {
    const updateTheme = () => {
       const bsTheme = document.documentElement.getAttribute("data-bs-theme");
      if (bsTheme === "dark") {
        setTheme("monokai"); // dark theme
      } else {
        setTheme("rjv-default"); // light theme
      }
    };

    // Run on mount
    updateTheme();

    // Listen for changes to data-bs-theme
    const observer = new MutationObserver(updateTheme);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-bs-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="mdv" style={{}}>
      <ReactJson
        src={result_mongo}
        name={null}
        theme={theme} // Try "monokai", "twilight", "ocean", etc.
        iconStyle="triangle"
        collapsed={false} // or set to `2` to auto-collapse after 2 levels
        enableClipboard={false}
        displayDataTypes={true}
        displayObjectSize={false}
        onEdit={false}
        onDelete={false}
        onAdd={false}
        style={{
          fontFamily: '"Fira Code", monospace',
          fontSize: 14,
          
          borderRadius: '4px',
        }}
      />
    </div>
  );
};

export default MongoJsonViewer;
